"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiIngestVideosClient = void 0;
const PageableConverter_1 = require("../../common/model/PageableConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const isNotEmpty_1 = require("./isNotEmpty");
class ApiIngestVideosClient extends ApiSubClient_1.ApiSubClient {
    async getAll(pageRequest, filterRequest) {
        const ingestVideosLink = await this.getLinkOrThrow('ingestVideos');
        if (!ingestVideosLink) {
            throw Error('Not authorized to view ingest videos');
        }
        const interpolationParams = {
            page: pageRequest.page,
            size: pageRequest.size,
        };
        if (filterRequest && (0, isNotEmpty_1.isNotEmpty)(filterRequest.channelName)) {
            interpolationParams.channel = filterRequest.channelName;
        }
        if (filterRequest && filterRequest.statuses) {
            interpolationParams.status = filterRequest.statuses;
        }
        return this.axios
            .get((0, expandUrlTemplate_1.default)(ingestVideosLink.href, interpolationParams))
            .then((response) => {
            return PageableConverter_1.PageableConverter.convert(response.data, 'ingestVideos', (response) => {
                return {
                    id: response.id,
                    title: response.title,
                    ingestJob: { id: response.ingestJob.id },
                    channel: {
                        id: response.channel.id,
                        name: response.channel.name,
                    },
                    status: response.status,
                    ingestStartedAt: new Date(response.ingestStartedAt),
                };
            });
        });
    }
}
exports.ApiIngestVideosClient = ApiIngestVideosClient;
//# sourceMappingURL=ApiIngestVideosClient.js.map